import {useEffect} from 'react';

const useEventListener = (type, listener, target = document) => {
    useEffect(() => {
        target.addEventListener(type, listener);

        return () => target.removeEventListener(type, listener);
    }, []);
};

export default useEventListener;
